export default __webpack_public_path__ + "static/media/Amazoneclone.f2d1ad9a.png";